import { Box, Grid, styled } from '@mui/material';

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-left: 2px solid var(--divider, rgba(0, 0, 0, 0.12));
`;

export const PreviewContainer = styled(Grid)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.brand.whitesmoke,
  border: `1px solid ${theme.palette.brand.disable}`,
  borderRadius: '4px',
  height: '300px',
  overflow: 'hidden',
}));

export const DetailsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
